import styled from "styled-components";

export const Title = styled.h1`
  font-weight: 700;
  font-size: 35px;
  line-height: 50px;
  @media (max-width: 820px) {
    margin-right: 5px;
  }
`;
